/* istanbul ignore file */
import React from 'react';
import { CreateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import JournalEntryBreadcrumbs from 'domain/finance/journalEntry/shared/JournalEntryBreadcrumbs';

const CreateLedgerBreadcrumbs = () => {
  return (
    <JournalEntryBreadcrumbs>
      <CreateBreadcrumbItem entity="Journal Entry" />
    </JournalEntryBreadcrumbs>
  );
};

export default CreateLedgerBreadcrumbs;
